import React from 'react';
import { Box, Typography } from '@mui/material';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined';
import SquareFootOutlinedIcon from '@mui/icons-material/SquareFootOutlined';
import { usePreviewHighlights } from '../hooks';
import { formatPrice } from '../utils';

const HighlightsSection: React.FC = () => {
  const {
    addressLine1,
    addressLine2,
    listPrice,
    beds,
    baths,
    halfBaths,
    sqft,
    aboveGrade,
    propertyType,
    mlsStatus,
    listingId,
  } = usePreviewHighlights();

  const displaySqft = aboveGrade || sqft;

  return (
    <Box sx={{ py: 3 }}>
      {/* Address */}
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, textTransform: 'uppercase' }}
      >
        {addressLine1 || 'Address Unavailable'}
      </Typography>
      {addressLine2 && (
        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            textTransform: 'uppercase',
            color: 'text.secondary',
            mb: 1,
          }}
        >
          {addressLine2}
        </Typography>
      )}

      {/* Price */}
      <Typography variant="h4" sx={{ fontWeight: 700, my: 1 }}>
        {formatPrice(listPrice)}
      </Typography>

      {/* Bed / Bath / SqFt row */}
      <Box
        sx={{
          display: 'flex',
          gap: 3,
          alignItems: 'center',
          my: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <BedOutlinedIcon fontSize="small" />
          <Typography variant="body1">Bed: {beds || '0'}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <BathtubOutlinedIcon fontSize="small" />
          <Typography variant="body1">
            Bath: {baths || '0'} full | {halfBaths || '0'} half
          </Typography>
        </Box>
        {displaySqft != null && String(displaySqft) !== '' && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <SquareFootOutlinedIcon fontSize="small" />
            <Typography variant="body1">
              {Number(displaySqft).toLocaleString()} finished sqft
            </Typography>
          </Box>
        )}
      </Box>

      {/* Status | Type | MLS# */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 500, color: 'text.secondary' }}
      >
        {[mlsStatus, propertyType, listingId].filter(Boolean).join('   |   ')}
      </Typography>
    </Box>
  );
};

export default React.memo(HighlightsSection);
